var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof mfe_avis_agencyInTheSpotlight !== "undefined") return resolve();
	__webpack_require__.l("https://www.seloger.com/assets/mfes/avis_agencyInTheSpotlight/v1/client/remoteEntry.js", (event) => {
		if(typeof mfe_avis_agencyInTheSpotlight !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "mfe_avis_agencyInTheSpotlight");
}).then(() => (mfe_avis_agencyInTheSpotlight));